import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FilterModel } from '../split-button-filter/split-button-filter.component';

@Component({
  selector: 'split-button-filters',
  templateUrl: './split-button-filters.component.html',
  styleUrls: ['./split-button-filters.component.scss']
})
export class SplitButtonFiltersComponent implements OnChanges {
  _filters: any = [];

  @Input() set filters(filters: any[])  {
    this._filters = filters.map((filter: any) => new FilterModel(filter))
  } 

  get filters() {
    return this._filters;
  }
  
  @Output() filtersChange: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
   if(changes["filters"]) {
     //
   }
  }

  updateFilter(event: any, position: number) {
    this._filters[position] = event;
    let data = this._filters?.flatMap((filter: any) => filter.data).filter((data: any) => data?.checklist == true);
    //console.log(filter.data.filter((x: any) => x.checklist == true))
    this.filtersChange.emit(this._filters);
    this.onChange.emit(data)

  }

}
